import { Injectable } from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Injectable()
export class SearchBarMobileService {

  public arrowIcon(isOneWayTrip: boolean, isVert: boolean): Icon {
    if (isVert) {
      return isOneWayTrip ? Icon.ArrowDown : Icon.SwapVert;
    } else {
      return isOneWayTrip ? Icon.ArrowRight : Icon.Roundtrip;
    }
  }

  public isEmptyDepartureDate(departureDate: Date, isSubmitted: boolean): boolean {
    return isNullOrUndefined(departureDate) && isSubmitted;
  }

  public isEmptyArrivalDate(arrivalDate: Date, isSubmitted: boolean): boolean {
    return isNullOrUndefined(arrivalDate) && isSubmitted;
  }
 
}
